import { SrchDataClient } from "@data/srchdata-client";
import { SrchDataGetBioParams } from "@data/srchdata-client/types";

import { wrapResponse } from "./wrapResponse"

async function getBioHandler(req, res) {
  // eslint-disable-next-line no-param-reassign
  res = wrapResponse(res);

  const params = req.query as SrchDataGetBioParams;

  const srchDataClient = SrchDataClient.init({
    host: process.env.SRCHDATA_URL
  });

  const srchDataClientResponse = await srchDataClient.getBio(params);

  return res.status(200).json(srchDataClientResponse);
}

export default getBioHandler;
